import { createReducer } from 'redux-act';
import actions from './commonActions';

const initialState = {
  sidebarOptions: { minimize: false, show: 'responsive' },
  messageNotification: null,
  getNotification:null,

  getNotificationPending: false,
  getNotificationRes: null,
  getNotificationError: null,
};

//
const handleToggleSidebar = (state, payload) => {
  return {
    ...state,
    ...{
      sidebarOptions: payload,
    },
  };
};

// clear existing data
const clearCommonStore = (state, payload) => {
  switch (payload) {
    case 'HANDLE_CLEAR':
      return {
        ...state,
        ...{
          sidebarOptions: { minimize: false, show: 'responsive' },
        },
      };
    case 'CLEAR_NOTIFICATION':
      return {
        ...state,
        ...{
          getNotification:null,
        },
      };
    default:
      return state;
  }
};
const handleMessageNotificationRequestReducer = (state, payload) => {
  return {
    ...state,
    ...{
      messageNotification: null,
    },
  };
};
const handleMessageNotificationSuccessReducer = (state, payload) => {
  return {
    ...state,
    ...{
      messageNotification: payload,
    },
  };
};
const handleNotificationSuccessReducer = (state,payload)=>{
  console.log("jksdf")
  return{
    ...state,
    ...{
      getNotification:payload,
    }
  }
}
const handleClearAllNotificationReducer = (state)=>{
  return{
    ...state,
    ...{
      getNotification:null,
    }
  }
}
const handleNotificationRequestReducer = (state)=>{
 
  return{
    ...state,
    ...{
      getNotification:[],
    }
  }
}

//get notification
const handleGetNotificationRequest = state => {
  return {
    ...state,
    ...{
      getNotificationPending: true,
  getNotificationRes: null,
  getNotificationError: null,
    },
  };
};
const handleGetNotificationSuccess = (state, payload) => {
  return {
    ...state,
    ...{
      getNotificationPending: false,
  getNotificationRes: payload,
  getNotificationError: null,
    },
  };
};
const handleGetNotificationError = (state, payload) => ({
  ...state,
  ...{
    getNotificationPending: false,
    getNotificationRes: null,
    getNotificationError: payload,
  },
});

export default createReducer(
  {
    [actions.toggleSidebar]: handleToggleSidebar,
    [actions.handleClearCommonStore]: clearCommonStore,
    [actions.handleMessageNotificationRequest]: handleMessageNotificationRequestReducer,
    [actions.handleMessageNotificationSuccess]: handleMessageNotificationSuccessReducer,
    [actions.handleNotificationSuccess]:handleNotificationSuccessReducer,
    [actions.handleNotificationRequest]:handleNotificationRequestReducer,
    [actions.handleClearAllNotification]:handleClearAllNotificationReducer,

    [actions.getNotificationRequest]:handleGetNotificationRequest,
    [actions.getNotificationSuccess]:handleGetNotificationSuccess,
    [actions.getNotificationError]:handleGetNotificationError,

  },
  initialState,
);
